import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-combine-large.tsx
/**
* icon.24.combine.large
*
* Keywords: waveform, audio, sound, frequency, equalizer, vertical, bars, music
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4IDRhMS45OTggMS45OTggMCAwIDEgLjQ5OSAzLjkzNFYxMC41QTIuNSAyLjUgMCAwIDEgMTYgMTNoLTFhMi41IDIuNSAwIDAgMC0yLjUgMi40ODdsLjAwMi4wMTN2My43OTNsMi4xNDYtMi4xNDZhLjUuNSAwIDAgMSAuNzA3LjcwN2wtMyAzYS41LjUgMCAwIDEtLjcwNyAwbC0zLTNhLjUuNSAwIDEgMSAuNzA3LS43MDdsMi4xNDYgMi4xNDV2LTMuODA2QTIuNSAyLjUgMCAwIDAgOSAxM0g4YTIuNSAyLjUgMCAwIDEtMi41LTIuNVY3LjkzNEExLjk5OCAxLjk5OCAwIDAgMSA2IDRhMS45OTggMS45OTggMCAwIDEgLjUgMy45MzRWMTAuNUExLjUgMS41IDAgMCAwIDggMTJoMWEzLjUgMy41IDAgMCAxIDMgMS42OTZBMy41IDMuNSAwIDAgMSAxNSAxMmgxYTEuNSAxLjUgMCAwIDAgMS41LTEuNVY3LjkzNEExLjk5NyAxLjk5NyAwIDAgMSAxOCA0TTYgNWExIDEgMCAxIDAgMCAyIDEgMSAwIDAgMCAwLTJtMTIgMGExIDEgMCAxIDAgMCAyIDEgMSAwIDAgMCAwLTIiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26627-10447
*/
const Icon24CombineLarge = memo(function Icon24CombineLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18 4a1.998 1.998 0 0 1 .499 3.934V10.5A2.5 2.5 0 0 1 16 13h-1a2.5 2.5 0 0 0-2.5 2.487l.002.013v3.793l2.146-2.146a.5.5 0 0 1 .707.707l-3 3a.5.5 0 0 1-.707 0l-3-3a.5.5 0 1 1 .707-.707l2.146 2.145v-3.806A2.5 2.5 0 0 0 9 13H8a2.5 2.5 0 0 1-2.5-2.5V7.934A1.998 1.998 0 0 1 6 4a1.998 1.998 0 0 1 .5 3.934V10.5A1.5 1.5 0 0 0 8 12h1a3.5 3.5 0 0 1 3 1.696A3.5 3.5 0 0 1 15 12h1a1.5 1.5 0 0 0 1.5-1.5V7.934A1.997 1.997 0 0 1 18 4M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24CombineLarge };

//# sourceMappingURL=icon-24-combine-large.js.map